import { bootTool } from '../../core/boot';
import { mountSecurityHeaders } from './ui';

bootTool('[data-kb-tool="security-headers-checker"]', mountSecurityHeaders);
